// extracted by mini-css-extract-plugin
export default {"videoLoopComponent":"VideoLoop_videoLoopComponent__djgMH"};